import Page from '../views/Page'
const isProduction = process.env.NODE_ENV === 'production'

let routes = [
	// 走网关
	{
		path: '/actgateway/act_csr/:pageKey',
		component: Page,
	},
	{
		path: '/actgateway/act_csr/draft/:pageKey',
		component: Page,
	},
	// QA环境
	{
		path: '/actgateway/actgateway/act_csr/:pageKey',
		component: Page,
	},
	{
		path: '/actgateway/actgateway/act_csr/draft/:pageKey',
		component: Page,
	},
	// 不走网关
	{
		path: '/mactivity/all/productView/:pageKey',
		component: Page,
	},
	{
		path: '/mactivity/all/draftView/:pageKey',
		component: Page,
	},
	// 不走网关 大型定制活动
	{
		path: '/mactivitycm/all/productView/:pageKey',
		component: Page,
	},
	{
		path: '/mactivitycm/all/draftView/:pageKey',
		component: Page,
	},
	{
		path: '/productview/all/productView/:pageKey',
		component: Page,
	},
	{
		path: '/productview/all/draftView/:pageKey',
		component: Page,
	},
	{
		path: '/actgateway/act_csr_stage/:pageKey',
		component: Page,
	},
	{
		path: '/actgateway/act_csr_stage/draft/:pageKey',
		component: Page,
	},
]

if (process.env.NODE_ENV !== 'production') {
	const testRoutes = [
		{
			path: '/mactivity/all/ui/toast',
			component: () => import('../components/common/toast/test.vue'),
		},
		{
			path: '/mactivity/all/ui/location',
			component: () => import('../components/common/location/test.vue'),
		},
		{
			path: '/mactivity/all/ui/locationNew',
			component: () => import('../components/common/locationByIp/test.vue'),
		},
		{
			path: '/mactivity/all/ui/citySelect',
			component: () => import('../components/common/citySelect/test.vue'),
		},
		{
			path: '/mactivity/all/ui/share',
			component: () => import('../components/common/share/test.vue'),
		},
	]
	routes = [...routes, ...testRoutes]
}
// 为私有部署特殊兼容
if (
	(window.currentRouteBaseUrl && window.currentRouteBaseUrl.length > 0) ||
	window.currentRouteBaseUrl === ''
) {
	routes.push({
		path: `${window.currentRouteBaseUrl}/act_csr/:pageKey`,
		component: Page,
	})
	routes.push({
		path: `${window.currentRouteBaseUrl}/act_csr/draft/:pageKey`,
		component: Page,
	})
}

const routerMap = {
	mode: 'history',
	base: '/',
	routes,
}

export default routerMap
